import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=c54dd56a"
import script from "./notification.vue?vue&type=script&setup=true&lang=js"
export * from "./notification.vue?vue&type=script&setup=true&lang=js"
import style0 from "./notification.vue?vue&type=style&index=0&id=c54dd56a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports